export default __webpack_public_path__ + "static/media/robotic-education.86bc34ff.svg";